export default __webpack_public_path__ + "static/media/logo-small.3be9857b.png";